import React from 'react';
import { FiEdit2, FiEye, FiTrash2 } from 'react-icons/fi';
import i18n from '../../../i18n';

// Row actions as icon buttons (view / edit / delete), styled by .cl-ico in customerMaster/customerListing.css.
// Delete shows only when an onDelete handler is given.
const RowActions = ({ data, onView, onEdit, onDelete, canDelete }) => {
  const act = (fn) => (e) => { e.stopPropagation(); fn?.(data); };
  return (
    <div className="cl-actions">
      <button type="button" className="cl-ico" title={i18n.t('common.view')} aria-label={i18n.t('common.view')} onClick={act(onView)}><FiEye size={18} /></button>
      <button type="button" className="cl-ico" title={i18n.t('common.edit')} aria-label={i18n.t('common.edit')} onClick={act(onEdit)}><FiEdit2 size={18} /></button>
      {onDelete && (
        <button
          type="button"
          className="cl-ico danger"
          disabled={!canDelete}
          title={canDelete ? i18n.t('common.delete') : i18n.t('common.onlyAdminCanDelete')}
          aria-label={i18n.t('common.delete')}
          onClick={canDelete ? act(onDelete) : undefined}
        ><FiTrash2 size={18} /></button>
      )}
    </div>
  );
};

export default RowActions;
